import { api } from "../../lib";

export interface ReportDeliveryMethod {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
  createdAt: string;
}

export interface CreateReportDeliveryMethodInput {
  name: string;
  description?: string;
  isActive?: boolean;
}

export interface UpdateReportDeliveryMethodInput
  extends Partial<CreateReportDeliveryMethodInput> {
  id: string;
}

export const reportDeliveryMethodsService = {
  getAll: async () => {
    return api.get<ReportDeliveryMethod[]>("/admin/report-delivery-methods");
  },

  getById: async (id: string) => {
    return api.get<ReportDeliveryMethod>(
      `/admin/report-delivery-methods/${id}`
    );
  },

  create: async (input: CreateReportDeliveryMethodInput) => {
    return api.post<ReportDeliveryMethod>(
      "/admin/report-delivery-methods",
      input
    );
  },

  update: async (input: UpdateReportDeliveryMethodInput) => {
    const { id, ...updates } = input;
    return api.put<ReportDeliveryMethod>(
      `/admin/report-delivery-methods/${id}`,
      updates
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/report-delivery-methods/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<ReportDeliveryMethod>(
      `/admin/report-delivery-methods/${id}`,
      { isActive }
    );
  },
};
